import { render, staticRenderFns } from "./NewTypeAgent.vue?vue&type=template&id=1e98014a"
import script from "./NewTypeAgent.vue?vue&type=script&lang=js"
export * from "./NewTypeAgent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports